module.exports = __webpack_public_path__ + "img/pickaxe-bronze.4af047fa.svg";